import { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { CopyToClipboard, CopyToClipboardWrapper } from '@10xLabs/react-web/components/CopyToClipboard'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import Heading from 'components/v2/Heading'
import { StyledLink } from 'components/v2/Link'
import Modal from 'components/v2/Modal'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from '@10xLabs/react-web/components/Table'
import { SaleStatus } from 'features/Sales/components/Status'

export const ActivitySales = ({ sales }: TSFixMe): TSFixMe => {
  const [isModalOpen, setModalOpen] = useState(false)

  return (
    <div>
      {sales.length > 0 ? (
        <div>
          <StyledLink onClick={(): TSFixMe => setModalOpen(true)}>{sales.length}</StyledLink>
        </div>
      ) : (
        0
      )}

      {isModalOpen && (
        <Modal.Container large>
          <Modal.Header onClose={(): TSFixMe => setModalOpen(false)}>
            <Heading.H5>
              <FormattedMessage id="spanish.cart.activity.sales.title" defaultMessage="Ventas" />
            </Heading.H5>
          </Modal.Header>

          <Modal.Content>
            <TableContainer overflow>
              <Table>
                <Thead>
                  <Tr>
                    <Th>
                      <FormattedMessage id="spanish.dictionary.id" defaultMessage="Id" />
                    </Th>

                    <Th>
                      <FormattedMessage id="spanish.dictionary.status" defaultMessage="Estado" />
                    </Th>

                    <Th>
                      <FormattedMessage id="spanish.dictionary.amount" defaultMessage="Monto" />
                    </Th>
                  </Tr>
                </Thead>

                <Tbody>
                  {sales.map((sale: TSFixMe, index: TSFixMe): TSFixMe => {
                    return (
                      <Tr key={index}>
                        <Td>
                          <CopyToClipboardWrapper>
                            <div>{sale.id.substring(0, 8)}</div>

                            <CopyToClipboard str={sale.id} />
                          </CopyToClipboardWrapper>
                        </Td>

                        <Td>
                          <SaleStatus status={sale.status} />
                        </Td>

                        <Td>
                          <FormattedPrice value={sale.amount} />
                        </Td>
                      </Tr>
                    )
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Modal.Content>
        </Modal.Container>
      )}
    </div>
  )
}
